<template>
    <div>
        <ModalTitle :bodyStyle="{ 'padding': '12px 24px 0px' }" :model-value="modelValue" :backdrop="backdrop"
            @update:model-value="onModelValue">
            <template #header>
                <div class="text-[24px] text-white font-[800] leading-[40px] tracking-[0.25px]">
                    {{ $t('niuniu.playList') }}</div>
            </template>

            <div class="flex justify-between items-center text-[12px] font-[500] leading-[12px] mb-[8px] pb-[8px]"
                style="border-bottom: 0.5px solid #FFFFFF1F;">
                <div class="text-grey-40">{{ $t('niuniu.user') }}/ <span class=" text-green">{{ onLineCount || 0
                        }}</span></div>
                <div class="text-grey-20">{{ $t('niuniu.amount') }}</div>
            </div>

            <div class="content-container">
                <div>
                    <ul v-if="playerList.length">
                        <li class="flex justify-between py-[10px]" v-for="(item, index) in playerList" :key="index"
                            style="border-bottom: 0.5px solid #FFFFFF1F;">
                            <div class="flex items-center gap-[8px]">
                                <UserAvatar size='20px' :src="item.user.avatar || defaultAvatar" />
                                <div class="text-[12px] text-white font-[600] leading-[12px] max-w-[118px] truncate">
                                    {{ item.user.name }}
                                </div>
                            </div>
                            <div class="flex items-center text-[14px] text-green font-[700] leading-[14px] tracking-[0.2px]">
                                <CurrentCoin size="18px" class="mr-[5px]" :name="item.currency" />
                                <span>{{ (item.balance).toFixed(2) }}</span>
                            </div>
                        </li>
                    </ul>
                    <Empty v-else>
                        <img width="134" height="132" src="@/assets/imgs/casino/no-data-image.webp" alt="">
                    </Empty>
                </div>
            </div>
        </ModalTitle>

    </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue';
import avatar from '../img/avatarImg_girl.png'
const defaultAvatar = avatar;

interface PlayerItem {
    _id?: number;
    avatar: string;
    name: string;
    totalAmount: string | number;
}

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false
    },
    backdrop: {
        type: Boolean,
        default: true,
    },
    playerList: {
        type: Array as PropType<PlayerItem[]>,
        default: () => []
    },
    loading: {
        type: Boolean,
        default: false
    },
    onLineCount:{
        type:Number,
        default: 0
    }
})
const { t: $tFn } = useNuxtApp().$i18n;

const emit = defineEmits(['update:modelValue'])
const onModelValue = (value) => {
    emit('update:modelValue', value)
}
</script>
<style lang="scss" scoped>
.content-container {
    max-height: 490px;
    height: 490px;
    overflow-y: auto;
    position: relative;
}

.tab-active {
    border-radius: 8px;
    background: var(--color_grey-60);
}
</style>